import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getAvailableProducts } from '../actions/purchases'
import { updateSelectedLanguage } from '../actions/new-logo'
import Pricing from '../components/Pricing'

const mapStateToProps = (state) => {
  return {
    newLogo: state.newLogo,
    availableProducts: state.purchases.availableProducts
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateLanguage: (lang) => {
      dispatch(updateSelectedLanguage(lang))
    },
    getAvailableProducts: (params) => {
      dispatch(getAvailableProducts(params))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Pricing))



// WEBPACK FOOTER //
// ./src/containers/Pricing.js